export default __webpack_public_path__ + "static/media/whats-branca.3944d07c.svg";